import { useState } from "react";
import { ModalSure } from "../../components/modalExcluir";
import { animationModal } from "../../utils";
import axiosInstance from "../../auth/axiosInstance";
import { ModalInfos } from "../../components/modal";
import Loading from "../../components/Loading";
import React from "react";

export default function Refresh() {

  const [showModal, setShowModal] = useState(false)
  const [showModal2, setShowModal2] = useState(false)
  const [isLoading, setIsLoading] = React.useState(false);

  function refreshDocker() {
    setIsLoading(true)
    setShowModal(false)
    axiosInstance.post('restart/obras_atlas_module_v1')
      .then(res => {
        setIsLoading(false)
        setShowModal2(true)
      })
      .catch(error => {
        setIsLoading(false)
        console.log(error)
      })

  }

  return (
    <section className="body-table-eap">
      <div className='header_coin'>
        <h1 className='title'>Reiniciar Atlas</h1>
        <span className='span_select'>Clique no botão abaixo para reiniar a aplicação ATLAS e atualizar a base de dados</span>
        <button onClick={() => setShowModal(true)} className='refresh__container_add_button'>Reiniciar ATLAS</button>
      </div>

      {isLoading && < Loading content="Aguarde enquanto reiniciamos o container" />}
      <ModalInfos
        checked={showModal2}
        onClick={() => setShowModal2(false)}
        label={'Container Reiniciado'}
      />

      <ModalSure
        checked={showModal}
        error
        label='Você realmente deseja reiniciar a aplicação?'
        onClick={() => setShowModal(false)}
        delete={() => refreshDocker()}
      />

    </section>
  )
}